<template>
  <div class="content-section" id="change-password">
    <div class="login-wrap">
      <div class="login-area">
        <div class="data-match">
          <div class="matched-item">대상아이디</div>
          <div class="matched-text">{{loginId.check}}</div>
        </div>
        <div class="login-item">
          <div class="input-area">
            <p class="tit">
              <label for="password" class="">비밀번호</label>
            </p>
            <input type="password" class="" id='password' v-model="password" aria-describedby="pw-guide" placeholder="비밀번호를 입력해 주세요" value="" title="비밀번호를 입력해 주세요">
          </div>
          <div class="desc mt-8" id="pw-guide">
            비밀번호는 숫자, 영문, 특수문자 포함 9자 이상이어야 합니다.
          </div>
        </div>
        <div class="login-item">
          <div class="input-area">
            <p class="tit">
              <label for="re-password" class="">비밀번호 재입력</label>
            </p>
            <input type="password" class="" id="re-password" v-model="passwordConfirm" placeholder="비밀번호를 다시 입력해 주세요." value="" title="비밀번호를 다시 입력해 주세요.">
          </div>
        </div>
        <div class="login-item">
          <div class="button-area">
            <button class="btn btn-primary btn-md" @click="changePassword">
              비밀번호 변경
            </button>
          </div>
        </div>
        <div class="login-item">
          <div class="desc">
            비밀번호찾기 문의 : 운영지원팀(TEL : 1661-5516)
          </div>
        </div>
      </div>
      <div class="find-area">
        <a href="/login.do">로그인</a>
        <a href="/joinSel.do?flag=join">회원가입</a>
      </div>
    </div>
  </div>
</template>
<script>
  import Axios from 'axios';

  export default {
    name: 'change-password',
    props: ['loginId'],
    data() {
      return {
        password: '',
        passwordConfirm: '',
      };
    },
    methods: {
      changePassword() {
        const pwdReg = /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^*()\-_=+\\|[\]{};:'",.<>/?~`&]).{9,50}$/i;
        if (!this.password) {
          alert('비밀번호를 입력해 주세요.');
          $('#password').focus();
        } else if (!this.passwordConfirm) {
          alert('비밀번호를 재입력해 주세요.');
          $('#re-password').focus();
        } else if (this.password !== this.passwordConfirm) {
          alert('비밀번호가 서로 일치하지 않습니다.');
          $('#re-password').focus();
        } else if (!pwdReg.test(this.password)) {
          alert('비밀번호는 숫자, 영문, 특수문자 포함 9자 이상이어야 합니다.');
          $('#password').focus();
        } else {
          const Params = {
            password: this.password,
          };
          Axios.post('/api/members/reset-password', Params).then(() => {
            alert('비밀번호가 변경되었습니다. 로그인 페이지로 돌아갑니다.');
            location.href = '/login.do';
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
    },
  };

</script>


// WEBPACK FOOTER //
// ChangePasswordJobType.vue?1f832af0